// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-group .header {\n    font-style: normal;\n    font-weight: bold;\n    font-size: 24px;\n    position: relative;\n}\n\n.product-group .header-title {\n    margin: 25px 30px;\n    margin-bottom: 10px;\n    margin-top: 0px;\n}\n", ""]);
// Exports
module.exports = exports;
